
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { QualificationResponse } from "../../models/dtos";

export const qualificationsApi = createApi({
  reducerPath: 'qualificationsApi',
  baseQuery: baseAuthQuery('Qualifications'),
  tagTypes: ['Qualification'],
  endpoints: (builder) => ({
    getQualifications: builder.query<ApiResponse<QualificationResponse[]>, void>({
      query: () => "",
      providesTags: ['Qualification'],
    }),
    getQualificationById: builder.query<ApiResponse<QualificationResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['Qualification'],
    }),
    updateQualification: builder.mutation<ApiResponse<QualificationResponse>, Partial<QualificationResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['Qualification'],
    }),
    deleteQualification: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['Qualification'],
    }),
  }),
});
